<div *transloco="let t">
	<ng-container>
		<div class="flex flex-col">
			<h3 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">{{ t('billing.addUserRole') }}</h3>
			<mat-dialog-content>
				<div [formGroup]="userRoleFormGroup">
					<div class="flex flex-col mt-2">
						<div>
							<mat-form-field appearance="outline" class="w-full">
								<mat-label>{{ t('billing.userRoleType') }}</mat-label>
								<mat-select formControlName="userRoleType">
									@for (userRoleType of availableUserRoleTypes(); track userRoleType) {
										<mat-option [value]="userRoleType">
											{{ t('enum.' + userRoleType) }}
										</mat-option>
									}
								</mat-select>
								<mat-error>
									{{ t('common.requiredField') }}
								</mat-error>
							</mat-form-field>
						</div>
						<div>
							<mat-form-field appearance="outline" class="w-full">
								<mat-label>{{ t('billing.userRoleName') }}</mat-label>
								<input formControlName="name" matInput placeholder="{{ t('billing.userRoleName') }}" />
								<mat-error>
									@if (userRoleFormGroup.get('name').value?.length < 100) {
										{{ t('errors.invalidSymbol') }}
									} @else {
										{{ t('errors.maxLength') }}
									}
								</mat-error>
							</mat-form-field>
						</div>
						<div>
							<mat-checkbox formControlName="vacancyPossible">{{ t('billing.userRoleVacancyPossible') }}</mat-checkbox>
						</div>
					</div>
				</div>
			</mat-dialog-content>
			<mat-dialog-actions class="flex flex-row justify-end items-center" mat-dialog-actions>
				<button (click)="close(false)" mat-raised-button>
					<mat-icon>cancel</mat-icon>
					@if (!layoutService.isMobile()) {
						{{ t('commonActions.cancel') }}
					}
				</button>
				<button [disabled]="!userRoleFormGroup.valid" (click)="close(true)" color="primary" mat-raised-button>
					<mat-icon>save</mat-icon>
					@if (!layoutService.isMobile()) {
						{{ t('commonActions.save') }}
					}
				</button>
			</mat-dialog-actions>
		</div>
	</ng-container>
</div>
